export const DEFAULT_VIDEO_STYLES = `
    video {
        width: 100%;
        height: 100%;
        max-width: 100%;
        max-height: 100%;
        object-fit: contain;
        object-position: center center;
        pointer-events: none;
        left: 0;
        top: 0;
        position: absolute;
    }

    video.fillMode {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }

    .playbackButton {
        transform: scale(var(--playbackButtonSize));
    }

    .play, .pause {
        width: 100%;
        height: 100%;
        position: absolute;
        fill: var(--playbackButtonColor);
        top: 0;
        left: 0;
    }

    .play {
        display: var(--playbackButtonPlayState)
    }

    .pause {
        display: var(--playbackButtonPauseState)
    }
`;
export const PLAYBACK_BUTTON_HTML = `
<svg class="play" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="100%" height="100%" viewBox="0 0 640 640" xml:space="preserve">
<g>
    <path d="M546.273 93.726C485.834 33.286 405.476 0 320 0 234.525 0 154.166 33.286 93.726 93.726S0 234.525 0 320c0 85.476 33.286 165.834 93.726 226.273C154.166 606.714 234.524 640 320 640s165.835-33.286 226.273-93.727C606.714 485.835 640 405.476 640 320s-33.286-165.834-93.727-226.274zM320 582C175.533 582 58 464.467 58 320 58 175.533 175.533 58 320 58c144.467 0 262 117.533 262 262 0 144.467-117.533 262-262 262z"/>
    <path d="M243.289 320V188.698L357 254.35 470.711 320 357 385.651l-113.711 65.651z"/>
</g>
</svg>
<svg class="pause" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="100%" height="100%" viewBox="0 0 640 640" xml:space="preserve">
<g>
    <path d="M546.273 93.726C485.834 33.286 405.476 0 320 0 234.525 0 154.166 33.286 93.726 93.726S0 234.525 0 320c0 85.476 33.286 165.834 93.726 226.273C154.166 606.714 234.524 640 320 640s165.835-33.286 226.273-93.727C606.714 485.835 640 405.476 640 320s-33.286-165.834-93.727-226.274zM320 582C175.533 582 58 464.467 58 320 58 175.533 175.533 58 320 58c144.467 0 262 117.533 262 262 0 144.467-117.533 262-262 262z"/>
    <path d="M375 192.854h52.486v254.291H375zM215 192.854h52.486v254.291H215z"/>
</g>
</svg>`;
